import { z } from 'zod'

export const myAccountGetDownloadFileSchema = z.object({
  /** 檔案名稱	 */
  fileName: z.string(),
  /** 檔案Id */
  fileId: z.string()
})

export interface MyAccountGetDownloadFile
  extends z.infer<typeof myAccountGetDownloadFileSchema> {}

export class MyAccountGetDownloadFile {
  constructor() {
    return {
      fileName: '',
      fileId: ''
    }
  }
}
